import LandingPage from './components/Landing/LandingPage';

// The public homepage. Previously a three-breakpoint card-carousel layout
// (MobileView / MidView / WideView) — replaced by a single responsive landing
// that routes visitors to the giveaway, the RPG (Epic Games) and contact.
const DynamicHomepage = () => {
  return <LandingPage />;
};

export default DynamicHomepage;
